const MarkerBasedSceneInit = () => {
  return (
    <a-scene
      embedded
      vr-mode-ui="enabled: false"
      xr-mode-ui="enabled: false"
      arjs="trackingMethod: best; sourceType: webcam; debugUIEnabled: false;"
      renderer="logarithmicDepthBuffer: true;"
      gltf-model="dracoDecoderPath: https://rhym.s3.ap-south-1.amazonaws.com/draco/"
      id="scene"
      // device-orientation-permission-ui="enabled: false"
    >
      <a-assets></a-assets>
      {/* <a-entity
        cursor="rayOrigin: mouse"
        raycaster="objects: .clickable"
      ></a-entity> */}

      <a-entity
        camera
        position="-0.1 0 0"
        // rotation="-90 0 0"
        // cursor="rayOrigin: mouse"
        // raycaster="objects: .clickable;"
      ></a-entity>

      {/* <a-camera>
        <a-entity
          cursor
          raycaster="objects: .clickable"
          position="0 0 0"
          geometry="primitive: ring; radiusInner: 0.02; radiusOuter: 0.03"
          material="color: white; shader: flat"
        ></a-entity>
      </a-camera> */}
      {/* <a-camera
        id="camera"
        // arjs-look-controls=" reverseMouseDrag: false; touchEnabled: false;smoothingFactor: 0.5"
        // look-controls-enabled="false"
        // wasd-controls-enabled="false"
        // position="0 2 10"
        // rotation="-90 0 0"
        tone-mapping="algorithm: reinhard;"
      ></a-camera> */}

      {/* <a-box
        id="ground"
        scale="1000 2 1000"
        position="0 -1 0"
        material="shader: shadow; transparent: true; opacity: 0.4"
        shadow
      ></a-box> */}
    </a-scene>
  );
};

export default MarkerBasedSceneInit;
